import { render, staticRenderFns } from "./desktop-nav-module.vue?vue&type=template&id=2a4e1822&scoped=true"
import script from "./desktop-nav-module.vue?vue&type=script&lang=js"
export * from "./desktop-nav-module.vue?vue&type=script&lang=js"
import style0 from "./desktop-nav-module.vue?vue&type=style&index=0&id=2a4e1822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e1822",
  null
  
)

export default component.exports